<script>
import api from '@/command/api'
import DetailFormGroup from '../../../components/DetailFormGroup'
import { getAction } from '@/command/netTool'
export default {
  data() {
    return {
      ...api.command.getState(),
      detail: {
        amount: null,
      },
      mergeBalanceList: [],
    }
  },
  mounted() {
    const { id } = this.$route.query
    getAction('/api/farmBalance/relationList').then((res) => {
      if (res.code == 200) {
        this.mergeBalanceList = res.data.map((e) => {
          return {
            ...e,
            name:  [e.areaName, e.name].filter((e) => e).join('/'),
            text: e.name,
            value: e.id,
          }
        })
        this.$forceUpdate()
      }
    })
    id &&
      api.command.getDetail
        .call(this, {
          url: `/farmBalance/detail/${id}`,
        })
        .then((result) => {
          this.detail.usedType = result.usedType ? result.usedType.split(',') : []
          this.detail.shopIds = result.shopBalanceList ? result.shopBalanceList.map((e) => e.relationId) : []
          this.$forceUpdate()
        })
  },
  methods: {
    getForm1() {
      return {
        title: '基本信息',
        type: 'cardForm',
        data: [
          {
            name: '充值卡名称',
            type: 'input',
            cols: 12,
            key: 'name',
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
          },
          {
            name: '金额',
            type: 'inputNumber',
            cols: 12,
            key: 'amount',
            rules: [
              {
                required: true,
                type: 'number',
              },
            ],
          },
        ],
      }
    },
    getForm3() {
      return {
        title: '关联余额券',
        type: 'cardForm',
        data: [
          {
            name: '卡券',
            cols: 12,
            key: 'mergeBalanceId',
            type: 'select',
            typeData: this.mergeBalanceList,
            onChange: (value) => {
              const obj = this.mergeBalanceList.find((e) => e.value == value) || { name: '' }
              this.detail.mergeBalanceName = obj.text
            },
            rules: [
              {
                required: true,
                type: 'string',
              },
            ],
            display: true,
          },
        ],
      }
    },
    getForm4() {
      return {
        title: '充值卡发放',
        type: 'cardForm',
        data: [
          {
            name: '初始数量',
            type: 'input',
            cols: 12,
            key: 'balanceNum',
            // rules: [
            //   {
            //     required: true,
            //   },
            //   {
            //     validator: (rule, value, callback) => {
            //       if (value) {
            //         const r = /^[0-9]*$/
            //         if (!r.test(value)) {
            //           callback('格式不正确')
            //           return
            //         }
            //         callback()
            //       }
            //     },
            //   },
            // ],
          },
        ],
      }
    },

    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: (data) => {
            api.command[data.id ? 'editPost' : 'create']
              .call(this, {
                url: `/farmBalance/${data.id ? 'editBalanceCard' : 'saveBalanceCard'}`,
                params: {
                  ...data,
                },
                isPost: false,
              })
              .then((result) => {
                this.$router.push('/marketingCenter/balanceRechargeCard')
              })
          },
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => this.$router.push('/marketingCenter/balanceRechargeCard'),
        },
      ]
      const right = [
        {
          name: '删除',
          popTitle: '确认删除吗?',
          isPop: true,
          type: 'danger',
          ghost: true,
          onClick: () => {
            api.command.delPut.call(this, {
              url: `/base/farmCouponRule/del?ids=${this.detail.id}`,
              isPost: false,
            })
            setTimeout(() => {
              this.$router.push('/marketingCenter/balanceRechargeCard')
            }, 500)
          },
        },
      ]
      return {
        left,
        right: this.detail.id && right,
      }
    },
  },
  render() {
    return (
      <div>
        <DetailFormGroup
          form={this.detail}
          foot={this.getFoot()}
          data={[this.getForm1(), this.getForm4(), this.getForm3()]}
        />
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
</style>
